<template>
  <div class="orderFeedback">
    <header class="fixed_Back_header flx">
      <div class="menu flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h3 style="padding-right:0">{{$t('howsYourProduct')}}</h3>
      </div>
    </header>
    <section class="main_content">
      <div
        class="product-card"
        v-if="orderDetails"
        @click="goToProductDetail(orderDetails.itemId,'NORMAL')"
      >
        <span class="product-img" v-if="orderDetails.displayImage">
          <img :src="orderDetails.displayImage" alt="item-image" />
        </span>
        <div class="product-detail">
          <div class="product-title">
            <h4>{{orderDetails.itemName}}</h4>
          </div>
        </div>
      </div>
      <ul class="option-list">
        <li
          class="option-item"
          v-for="(item,index) in orderDetails.productFeatureDTOs"
          :key="index"
        >
          <h5 class="heading">{{item.name}}</h5>
          <star-rating
            @current-rating="setCurrentRating($event, item.id)"
            :starSize="40"
            :rating="Number(item.rating)"
            :show-rating="false"
            active-color="#138808"
          ></star-rating>
        </li>
        <li class="option-item">
          <h5 class="heading">{{$t('inputProductPic')}}</h5>
          <AddFeedBackPhoto
            v-model="addFeedBackPhoto"
            @uploadImageList="previewPhoto"
            :previousImages="checkOrderDetail()"
          />
        </li>
        <li class="option-item">
          <h5 class="heading">{{$t('writeSomethingAboutProduct')}}</h5>
          <textarea
            name
            id
            rows="6"
            :placeholder="$t('tellUsWhatYouLiked')"
            v-model="orderDetails.comments"
          ></textarea>
        </li>
      </ul>
      <div class="shipping_button">
        <button
          class="order-track-btn"
          type="button"
          @click="feedbackSubmit()"
        >{{$t('submitFeedback')}}</button>
      </div>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>

<script>
import constant from "../../utils/constant";
import "../../assets/css/order-history.scss";
import StarRating from "vue-star-rating";
import AddFeedBackPhoto from "./AddFeedBackPhoto";
import ApiCaller from "../../utils/apicaller";
import CustomToaster from "../Common/CustomToaster";
export default {
  name: "OrderFeedBack",
  components: {
    StarRating,
    AddFeedBackPhoto,
    CustomToaster
  },
  data() {
    return {
      orderDetails: {},
      loading: false,
      addFeedBackPhoto: null,
      toasterData: {},
      isValidDetail: false
    };
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOrderFeedback();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToProductDetail(id) {
      this.$router.push("/detail/" + id);
    },
    checkOrderDetail() {
      return this.orderDetails.urls == null ? [] : this.orderDetails.urls;
    },
    setCurrentRating(rating, id) {
      this.orderDetails.productFeatureDTOs = this.orderDetails.productFeatureDTOs.map(
        function(val, index) {
          if (val.id == id) {
            return { id: id, rating: rating, name: val.name };
          } else {
            return { id: val.id, rating: val.rating, name: val.name };
          }
        }
      );
    },
    previewPhoto(photofile) {
      this.orderDetails.urls = photofile;
    },
    getOrderFeedback() {
      this.loading = true;
      ApiCaller(
        constant.PRODUCT_RATING,
        "get-order-rating-by-user/" + this.$route.params.orderId,
        "get"
      )
        .then(data => {
          this.loading = false;
          this.orderDetails = data.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },

    isRatingGiven(_ratingArr) {
      let isRating = false;
      _ratingArr.forEach(element => {
        if (element.rating != null) {
          isRating = !isRating;
        }
      });
      return isRating;
    },

    feedbackSubmit() {
      if (this.orderDetails.comments) {
        if (!this.isRatingGiven(this.orderDetails.productFeatureDTOs)) {
          this.toasterData = {
            msg: this.$t("selectOption"),
            color: "#e51c24",
            iconName: "close"
          };
          this.isValidDetail = true;
        } else{
           this.loading = true;
          const obj = {
            orderId: this.$route.params.orderId,
            productFeatureRatingDTOs: this.orderDetails.productFeatureDTOs,
            urls: this.orderDetails.urls,
            comments: this.orderDetails.comments
          };
          ApiCaller(
            constant.PRODUCT_RATING,
            "add-order-rating-by-user",
            "post",
            obj
          )
            .then(data => {
              this.loading = false;
              if (this.orderDetails.id) {
                this.$router.replace(
                  "/feedback-result/" +
                    this.$route.params.orderId +
                    "?ratingId=" +
                    this.orderDetails.id
                );
              } else {
                this.$router.push(
                  "/feedback-result/" + this.$route.params.orderId
                );
              }
            })
            .catch(err => {
              this.loading = false;
              console.log(err);
            });
        }
      } else {
        this.toasterData = {
          msg: this.$t("writeSomethingAboutProduct"),
          color: "#e51c24",
          iconName: "close"
        };
        this.isValidDetail = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.orderFeedback {
  .main_content {
    background: #f4f6f8;
    .product-card {
      background: none;
      margin-top: 8px;
    }
    .option-item {
      background: #fff;
      padding: 15px;
      margin: 8px 15px;

      .heading {
        font-size: 1em;
        font-weight: 600;
        margin-bottom: 8px;
      }
      .uploadFile input[type="file"] {
        display: none;
      }
      .message {
        color: #505050;
        font-size: 0.875em;
        line-height: 1.5;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          border: 1px dashed #32c5ff;
          padding: 5px 12px;
          border-radius: 25px;
          margin: 8px 8px 4px 0;
          font-size: 0.875em;
          color: #32c5ff;
          font-weight: 600;
          position: relative;
          &.choosed_option {
            background: #32c5ff;
            color: #fff;
          }
          .clear-option {
            position: absolute;
            right: -5px;
            top: -5px;
          }
        }
      }
      textarea {
        width: 100%;
        border-radius: 10px;
        padding: 8px;
        margin: 8px 0px 0px;
        &:focus {
          outline: 0;
        }
      }
    }
  }
}
</style>